import sendLocalRequest from "./sendLocalRequest";

export const getMachinesCount = (auth_token) => {
    return  new Promise( (resolve, reject) => {
        sendLocalRequest(`machines/count`, "GET", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
